import { render } from "./DashboardWorkflowCard.vue?vue&type=template&id=8ecba5e4&scoped=true"
import script from "./DashboardWorkflowCard.vue?vue&type=script&lang=js"
export * from "./DashboardWorkflowCard.vue?vue&type=script&lang=js"

import "./DashboardWorkflowCard.vue?vue&type=style&index=0&id=8ecba5e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ecba5e4"]])

export default __exports__